export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Cyrillic-3028d912b8189a439418248062179b7b.woff2";